import Vue from "vue";
import Router from "vue-router";
import store from "@/store/";
import Home from "./views/Home.vue";
import Login from "./views/Login.vue";
import LoginApi from "@/services/login";
import Productos from "./views/Productos.vue";
import Seguimiento from "./views/Seguimiento.vue";
import Iconos from "./views/Iconos.vue";
import Vendedores from "./views/Vendedores.vue";
import Permisos from "./views/Permisos.vue";
import SinPermiso from "./views/SinPermiso.vue";
import Supervisores from "./views/Supervisores.vue";
import Categoria from "./views/Categoria.vue";
import Cobros from "./views/Cobros.vue";
import Linea from "./views/Linea.vue";
import { Loading } from "element-ui";
Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/home",
      name: "home",
      component: Home,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/",
      name: "login",
      component: Login,
      meta: {
        isPublic: true,
        isLog: true
      }
    },
    {
      path: "/supervisores",
      name: "supervisores",
      component: Supervisores,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/cobros",
      name: "cobros",
      component: Cobros,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/linea",
      name: "linea",
      component: Linea,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/iconos",
      name: "iconos",
      component: Iconos,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/categoria",
      name: "categoria",
      component: Categoria,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/vendedores",
      name: "vendedores",
      component: Vendedores,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/seguimiento",
      name: "seguimiento",
      component: Seguimiento,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/productos",
      name: "productos",
      component: Productos,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/sinpermiso",
      name: "sinpermiso",
      component: SinPermiso,
      meta: {
        isPublic: false
      }
    },
    {
      path: "/permisos",
      name: "permisos",
      component: Permisos,
      meta: {
        isPublic: false
      }
    }
  ]
});
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.isPublic);
  if (requiresAuth === false) {
    LoginApi.refreshtoken()
      .then(res => {
        store.dispatch("setuser", res.data.usuario);
        if (to.path == "/productos") {
          let bols = false;
          let bols2 = false;
          let loadingInstance = Loading.service({ fullscreen: true });
          if (store.state.webtendencia.permisos) {
            for (let i = 0; i < store.state.webtendencia.permisos.length; i++) {
              if (store.state.webtendencia.permisos[i].ruta === "Productos") {
                bols = true;
                for (
                  let j = 0;
                  j < store.state.webtendencia.permisos[i].accion.length;
                  j++
                ) {
                  if (store.state.webtendencia.permisos[i].accion[j] === "Ver") {
                    bols2 = true;
                    loadingInstance.close();
                    next();
                  }
                }
              }
            }
          }
          if (bols === false || bols2 === false) {
            loadingInstance.close();
            // window.location.href = "/sinpermiso";
            next("/sinpermiso");
          }
        } else if (to.path == "/permisos") {
          let bols = false;
          let bols2 = false;
          let loadingInstance = Loading.service({ fullscreen: true });
          if (store.state.webtendencia.permisos) {
            for (let i = 0; i < store.state.webtendencia.permisos.length; i++) {
              if (store.state.webtendencia.permisos[i].ruta === "Empleados") {
                bols = true;
                for (
                  let j = 0;
                  j < store.state.webtendencia.permisos[i].accion.length;
                  j++
                ) {
                  if (store.state.webtendencia.permisos[i].accion[j] === "Ver") {
                    bols2 = true;
                    loadingInstance.close();
                    next();
                  }
                }
              }
            }
          }
          if (bols === false || bols2 === false) {
            loadingInstance.close();
            // window.location.href = "/sinpermiso";
            next("/sinpermiso");
          }
        } else if (to.path == "/seguimiento") {
          let bols = false;
          let bols2 = false;
          let loadingInstance = Loading.service({ fullscreen: true });
          if (store.state.webtendencia.permisos) {
            for (let i = 0; i < store.state.webtendencia.permisos.length; i++) {
              if (store.state.webtendencia.permisos[i].ruta === "Seguimiento") {
                bols = true;
                for (
                  let j = 0;
                  j < store.state.webtendencia.permisos[i].accion.length;
                  j++
                ) {
                  if (store.state.webtendencia.permisos[i].accion[j] === "Ver") {
                    bols2 = true;
                    loadingInstance.close();
                    next();
                  }
                }
              }
            }
          }
          if (bols === false || bols2 === false) {
            loadingInstance.close();
            // window.location.href = "/sinpermiso";
            next("/sinpermiso");
          }
        } else if (to.path == "/iconos") {
          let bols = false;
          let bols2 = false;
          let loadingInstance = Loading.service({ fullscreen: true });
          if (store.state.webtendencia.permisos) {
            for (let i = 0; i < store.state.webtendencia.permisos.length; i++) {
              if (store.state.webtendencia.permisos[i].ruta === "Iconos") {
                bols = true;
                for (
                  let j = 0;
                  j < store.state.webtendencia.permisos[i].accion.length;
                  j++
                ) {
                  if (store.state.webtendencia.permisos[i].accion[j] === "Ver") {
                    bols2 = true;
                    loadingInstance.close();
                    next();
                  }
                }
              }
            }
          }
          if (bols === false || bols2 === false) {
            loadingInstance.close();
            // window.location.href = "/sinpermiso";
            next("/sinpermiso");
          }
        } else if (to.path == "/supervisores") {
          let bols = false;
          let bols2 = false;
          let loadingInstance = Loading.service({ fullscreen: true });
          if (store.state.webtendencia.permisos) {
            for (let i = 0; i < store.state.webtendencia.permisos.length; i++) {
              if (store.state.webtendencia.permisos[i].ruta === "Supervisores") {
                bols = true;
                for (
                  let j = 0;
                  j < store.state.webtendencia.permisos[i].accion.length;
                  j++
                ) {
                  if (store.state.webtendencia.permisos[i].accion[j] === "Ver") {
                    bols2 = true;
                    loadingInstance.close();
                    next();
                  }
                }
              }
            }
          }
          if (bols === false || bols2 === false) {
            loadingInstance.close();
            // window.location.href = "/sinpermiso";
            next("/sinpermiso");
          }
        } else if (to.path == "/categoria") {
          let bols = false;
          let bols2 = false;
          let loadingInstance = Loading.service({ fullscreen: true });
          if (store.state.webtendencia.permisos) {
            for (let i = 0; i < store.state.webtendencia.permisos.length; i++) {
              if (store.state.webtendencia.permisos[i].ruta === "Categoria") {
                bols = true;
                for (
                  let j = 0;
                  j < store.state.webtendencia.permisos[i].accion.length;
                  j++
                ) {
                  if (store.state.webtendencia.permisos[i].accion[j] === "Ver") {
                    bols2 = true;
                    loadingInstance.close();
                    next();
                  }
                }
              }
            }
          }
          if (bols === false || bols2 === false) {
            loadingInstance.close();
            // window.location.href = "/sinpermiso";
            next("/sinpermiso");
          }
        } else if (to.path == "/linea") {
          let bols = false;
          let bols2 = false;
          let loadingInstance = Loading.service({ fullscreen: true });
          if (store.state.webtendencia.permisos) {
            for (let i = 0; i < store.state.webtendencia.permisos.length; i++) {
              if (store.state.webtendencia.permisos[i].ruta === "Linea") {
                bols = true;
                for (
                  let j = 0;
                  j < store.state.webtendencia.permisos[i].accion.length;
                  j++
                ) {
                  if (store.state.webtendencia.permisos[i].accion[j] === "Ver") {
                    bols2 = true;
                    loadingInstance.close();
                    next();
                  }
                }
              }
            }
          }
          if (bols === false || bols2 === false) {
            loadingInstance.close();
            // window.location.href = "/sinpermiso";
            next("/sinpermiso");
          }
        } else if (to.path == "/cobros") {
          let bols = false;
          let bols2 = false;
          let loadingInstance = Loading.service({ fullscreen: true });
          if (store.state.webtendencia.permisos) {
            for (let i = 0; i < store.state.webtendencia.permisos.length; i++) {
              if (store.state.webtendencia.permisos[i].ruta === "Cobros") {
                bols = true;
                for (
                  let j = 0;
                  j < store.state.webtendencia.permisos[i].accion.length;
                  j++
                ) {
                  if (store.state.webtendencia.permisos[i].accion[j] === "Ver") {
                    bols2 = true;
                    loadingInstance.close();
                    next();
                  }
                }
              }
            }
          }
          if (bols === false || bols2 === false) {
            loadingInstance.close();
            // window.location.href = "/sinpermiso";
            next("/sinpermiso");
          }
        } else {
          next();
        }
      })
      .catch(error => {
        console.log(error);
        next("/");
      });
  } else {
    if (to.path == "/") {
      LoginApi.refreshtoken()
        .then(res => {
          store.dispatch("setuser", res.data.usuario);
          next("/home");
        })
        .catch(error => {
          console.log(error);
          //next("/login")
        });
    }
    next();
  }
});

export default router;
